import { http } from "@common";
import endpoint from "../endpoint_cis";

export default {
    sendCode: (data) => {
        return http.get(endpoint.email.send_code_get, data);
    },
    validateLogin: (data) => {
        return http.get(endpoint.email.validate_and_login, data);
    },
};